
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agents/[locator]",
      function () {
        return require("private-next-pages/agents/[locator].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agents/[locator]"])
      });
    }
  